import React from 'react'
import Logotipo from './../layout/logotipo.component'
import LogotipoMuvicard from './../layout/logotipo-muvicard.component'
import LogotipoMuvibus from './../layout/logotipo-muvibus.component'
import BaseHeader from './base-header.component'
import Hamburguer from './../buttons/hamburguer.component'
import {
	StyledContainerHeader,
	StyledBackToTopBtn,
	MenuHorizontal,
	StyledLinksBlock,
	MenuSubContainer,
	LogoContainer
} from './styles/styled-header.style'
import { routes } from '../../constants/routes.constants'
import { connect } from 'react-redux'
import { userActions } from '../../actions'
import { UserService } from '../../services/user.service'
import { Link, withRouter } from 'react-router-dom'
import { bindActionCreators } from 'redux'
import { Creators as SiteCreators } from '../../ducks/site/site'
import { RoleConstants } from '../../constants'
import { LINKS_TITLE } from '@constants'
import { homeMenuConstants } from '../../constants/homemenu.constants'
import { isMobile, scrollToTop } from './../../helpers/window.helper'
import { Creators as TicketSaleCreators } from '../../ducks/ticket-sale/ticket-sale'
import { checkTokenExpired } from '../../helpers/token.helper'
import FontAwesome from 'react-fontawesome'
import MenuItem from '../icons/menu-item.component'
import MuvicardMenuItem from '../icons/muvicard-menu-item.component'
import MuvicardItemActionComponent from '../icons/muvicard-item-action.component'
import '../icons/muvicard-menu-item.style.scss'
import { parseJwt } from '@helpers'

class SiteHeaderComponent extends BaseHeader {
	constructor(props) {
		super(props)
		this.unmounted = false
		this.onClickPointsSolicitation = this.onClickPointsSolicitation.bind(this)
		this.state = {
			isClient: false,
			isLoggedIn: null,
			privateURL: '/',
			scrollMenuClass: 'left',
			scroll: 0,
			muvicardUrl: false,
			muvibusUrl: false
		}

		this.muvibusItens = [
			{
				title: LINKS_TITLE.CARTAO_MUVICARD,
				iconItem: homeMenuConstants.MUVICARD,
				route: routes.MUVICARD
			},
			{
				title: LINKS_TITLE.PERGUNTAS_FREQUENTES,
				iconItem: homeMenuConstants.QUESTIONICON,
				route: routes.FAQ
			},
			{
				title: LINKS_TITLE.BLOG,
				iconItem: homeMenuConstants.BLOGICON,
				route: routes.BLOG,
				renderUrl: true
			}
		]

		this.menuItens = [
			{
				title: LINKS_TITLE.CARTAO_MUVICARD,
				iconItem: homeMenuConstants.MUVICARD,
				route: routes.MUVICARD
			},
			// {
			// 	title: LINKS_TITLE.COMPRE_E_GANHE',
			// 	iconItem: homeMenuConstants.HANDMONEYICON,
			// 	route: routes.CLIENTE + routes.COMPRE_E_GANHE,
			// },
			{
				title: LINKS_TITLE.LOJA,
				iconItem: homeMenuConstants.EXCHANGEICON,
				route: routes.LOJA
			},
			{
				title: LINKS_TITLE.COMPRAR_PONTOS,
				iconItem: homeMenuConstants.CARTICON,
				route: routes.CLIENTE + routes.COMPRA_DE_PONTOS
			},
			// {
			// 	title: LINKS_TITLE.PONTOS_PRESENTES,
			// 	iconItem: homeMenuConstants.GIFTICON,
			// 	route: routes.CLIENTE + routes.PONTOS_PRESENTE,
			// },
			// {
			// 	title: LINKS_TITLE.CONVIDAR_AMIGOS,
			// 	iconItem: homeMenuConstants.HANDSSHAKEICON,
			// 	route: routes.CLIENTE + routes.CONVIDE_AMIGOS,
			// },
			// {
			// 	title: LINKS_TITLE.CLUBE_MUVIFLEX,
			// 	iconItem: homeMenuConstants.MOVEFLEXCLUBINCON,
			// 	route: routes.CLIENTE + routes.PLANOS,
			// },
			// {
			// 	title: LINKS_TITLE.SOLICITAR_PONTOS,
			// 	iconItem: homeMenuConstants.HANDMONEYICON,
			// 	route: routes.CLIENTE + routes.SOLICITACAO_DE_PONTOS
			// },
			{
				title: LINKS_TITLE.PERGUNTAS_FREQUENTES,
				iconItem: homeMenuConstants.QUESTIONICON,
				route: routes.FAQ
			},
			// {
			// 	title: LINKS_TITLE.BLOG,
			// 	iconItem: homeMenuConstants.BLOGICON,
			// 	route: routes.BLOG,
			// 	renderUrl: true,
			// },
			{
				title: LINKS_TITLE.FALE_CONSOCE,
				iconItem: homeMenuConstants.ATENDIMENTOICON,
				route: routes.ATENDIMENTO,
				renderUrl: true,
				viewBox: '20 0 128 192'
			},
			{
				title: LINKS_TITLE.COMPRE_VIA_WHATS,
				iconItem: homeMenuConstants.WHATSAPPICON,
				route: routes.WHATSAPP,
				renderUrl: true,
				viewBox: '10 0 128 192'
			},
			{
				title: LINKS_TITLE.MINHAS_COMPRAS,
				iconItem: homeMenuConstants.ICONMYSHOPPING,
				route: routes.CLIENTE + routes.ICONMYSHOPPING,
				viewBox: '10 0 128 192'
			},
			{
				title: LINKS_TITLE.INSTITUCIONAL,
				iconItem: homeMenuConstants.INSTITUCIONAL,
				renderUrl: true,
				route: routes.INSTITUCIONAL,
				viewBox: '0 -960 960 960'
			},
			{
				title: LINKS_TITLE.ACESSIBILIDADE,
				iconItem: homeMenuConstants.ACCESSIBILITY,
				route: routes.ACCESSIBILITY,
				viewBox: '0 0 35 30'
			},
			{
				title: LINKS_TITLE.NOTA_FISCAL,
				iconItem: homeMenuConstants.BILL,
				route: routes.CLIENTE + routes.NOTA_FISCAL,
				viewBox: '-2 -5 25 30'
			}
		]
	}

	CheckIfUserIsClient = roles =>
		roles.find(role => role == RoleConstants.Client)

	getPrivateUrl = roles => {
		switch (roles[0]) {
			case RoleConstants.Client:
				return `${routes.CLIENTE}${routes.SIMULADOR}`

			case RoleConstants.Admin:
				return routes.ADMIN

			case RoleConstants.SacUp:
				return routes.ADMIN

			case RoleConstants.Sac:
				return routes.ADMIN

			case RoleConstants.Partner:
				return routes.PARCEIRO

			case RoleConstants.Requester:
				return `${routes.CLIENTE}${routes.COMPRA_DE_PASSAGEM}`

			case RoleConstants.Financial:
				return routes.ADMIN

			case RoleConstants.PublicBody:
				return `${routes.CLIENTE}${routes.COMPRA_DE_PASSAGEM}`

			default:
				return `${routes.CLIENTE}${routes.COMPRA_DE_PASSAGEM}`
		}
	}

	componentDidMount() {
		this.interval = setInterval(
			() => this.setState({ scroll: window.pageYOffset }),
			100
		)

		let url = location.pathname
		this.setState({
			muvicardUrl: url.includes('muvicard')
		})
		this.setState({
			muvibusUrl: url.includes('muvibus')
		})
	}

	componentWillMount() {
		this.checkUser(this.props.accessToken)
	}

	componentWillUnmount() {
		this.unmounted = true
		clearInterval(this.interval)
	}

	checkUser = async accessToken => {
		if (this.unmounted) return

		const isLoggedIn = Boolean(accessToken)

		if (checkTokenExpired(accessToken)) {
			this.props.logout()
			return
		}

		const { role } = parseJwt(accessToken)

		isLoggedIn && role.length
			? this.setLoggedState(role)
			: this.setDefaultState()
	}

	setLoggedState = roles =>
		this.setState({
			isClient: this.CheckIfUserIsClient(roles),
			privateURL: this.getPrivateUrl(roles),
			isLoggedIn: true
		})

	setDefaultState = () =>
		this.setState({
			isClient: false,
			privateURL: '/',
			isLoggedIn: false
		})

	componentWillReceiveProps(nextProps) {
		if (this.unmounted) return false
		const { isLoggedIn } = this.state
		const { id, accessToken } = nextProps
		const userChanged = this.props.id !== id || (!isLoggedIn && !!accessToken)

		if (userChanged) this.checkUser(accessToken)
	}

	openMobileMenu = () => {
		const { openMobileMenu, closePrivateMenu } = this.props
		closePrivateMenu()
		openMobileMenu()
	}

	renderMenuItem = () => {
		const { hasMuvicard } = this.props

		this.menuItens.forEach(item => {
			if (item.route === routes.MUVICARD && hasMuvicard) {
				item.route = routes.MEU_CARTAO
			}
		})

		return this.menuItens.map((menu, key) => (
			<MenuItem
				label={menu.title}
				iconItem={menu.iconItem}
				route={menu.route}
				key={key}
				renderUrl={menu.renderUrl}
				viewBox={menu.viewBox}
			/>
		))
	}

	renderMuvibusMenu = () => {
		return this.muvibusItens.map((menu, key) => (
			<MenuItem
				label={menu.title}
				iconItem={menu.iconItem}
				route={menu.route}
				viewBox={menu.viewBox}
				key={key}
			/>
		))
	}

	onScrollMenu = ({ target: { scrollLeft } }) => {
		if (scrollLeft >= 180) this.setState({ scrollMenuClass: 'right' })
		if (scrollLeft < 179 && scrollLeft > 20)
			this.setState({ scrollMenuClass: 'both' })
		if (scrollLeft < 20) this.setState({ scrollMenuClass: 'left' })
	}

	onClickBackToTop = () => {
		scrollToTop()
	}

	onClickPointsSolicitation() {
		const { history, isLoggedIn, closeMobileMenu } = this.props
		const pointsSolicitationUrl = `${routes.CLIENTE}/solicitacao-de-pontos`

		closeMobileMenu()

		if (isLoggedIn) {
			history.push(pointsSolicitationUrl)
		} else {
			location.href = `${routes.ENTRAR}?redirecionamento=${pointsSolicitationUrl}`
		}
	}

	renderMyCardMenu = () => {
		return (
			<React.Fragment>
				<MuvicardMenuItem
					title={LINKS_TITLE.IR_PARA_MUVIFLEX}
					iconItem={homeMenuConstants.EXCHANGEICON}
					route={'/'}
					renderUrl={false}
				/>
				<MuvicardMenuItem
					title={LINKS_TITLE.FATURAS}
					viewBox={'0 0 20 22'}
					iconItem={homeMenuConstants.BILL}
					route={routes.MEU_CARTAO}
					renderUrl={false}
				/>
				<MuvicardMenuItem
					title={LINKS_TITLE.REDEFINIR_SENHA_MUVICARD}
					viewBox={'0 0 26 12'}
					iconItem={homeMenuConstants.RESETPASSWORD}
					route={routes.MEU_CARTAO_REDEFINIR_SENHA}
					renderUrl={false}
				/>
				<MuvicardItemActionComponent
					title={LINKS_TITLE.BLOQUEAR_DESBLOQUEAR_CARTAO}
					iconItem={homeMenuConstants.LOCKCARD}
					route={routes.MUVICARD}
				/>
				<MuvicardMenuItem
					title={LINKS_TITLE.CANCELAR_CARTAO}
					viewBox={'0 0 102 87'}
					iconItem={homeMenuConstants.CANCELCARD}
					route={routes.MEU_CARTAO_CANCELAR}
					renderUrl={false}
				/>
			</React.Fragment>
		)
	}

	render() {
		const {
			name,
			logout,
			hasMuvicard,
			transparent,
			moveflexNumber,
			closeMobileMenu,
			mobileMenuState
		} = this.props

		const {
			isClient,
			privateURL,
			isLoggedIn,
			muvicardUrl,
			muvibusUrl
		} = this.state

		const isMobileScreen = isMobile()

		let linksClass = mobileMenuState ? 'menu__links is-open' : 'menu__links'
		linksClass += isLoggedIn ? ' logged-in' : ''

		return (
			<StyledContainerHeader transparent={transparent}>
				<MenuSubContainer>
					<LogoContainer>
						<Link
							className="header__logo"
							to="/"
							onClick={() => {
								this.props.resetRebookingData()
							}}>
							{muvicardUrl && hasMuvicard ? (
								<LogotipoMuvicard />
							) : muvibusUrl ? (
								<LogotipoMuvibus />
							) : (
								<Logotipo />
							)}
						</Link>
					</LogoContainer>
					{!isMobileScreen && (
						<MenuHorizontal>
							{muvicardUrl && hasMuvicard ? (
								<div className="scrollCardMenu">
									{this.renderMyCardMenu()}
								</div>
							) : (
								<div className="scrollmenu">
									{muvibusUrl
										? this.renderMuvibusMenu()
										: this.renderMenuItem()}
								</div>
							)}
						</MenuHorizontal>
					)}
					<div className={`menu logged-${isLoggedIn}`}>
						<div className="mobile-menu">
							<Hamburguer
								onClick={() =>
									mobileMenuState
										? closeMobileMenu()
										: this.openMobileMenu()
								}
								isOpen={mobileMenuState}
							/>
						</div>
						<div className={linksClass}>
							{isLoggedIn && (
								<StyledLinksBlock className="menu__links-block">
									<Link
										to={privateURL}
										onClick={closeMobileMenu}
										className="blue bold name white-when-desktop">
										Olá {UserService.getFirstName(name)}!
										{isClient && (
											<div className="gray white-when-desktop">
												Nº Muviflex: {moveflexNumber}
											</div>
										)}
									</Link>
								</StyledLinksBlock>
							)}
							{isMobileScreen ? (
								<StyledLinksBlock className="menu__links-block">
									<div
										className={`box-login-mobile logged-${isLoggedIn}`}>
										{!isLoggedIn && (
											<div className="cadastre-se-div">
												<span className="ganhe-descontos">
													GANHE DESCONTOS E MUITO MAIS!
												</span>
												<div className="box-cadastro">
													<Link
														className="cadastre-se-btn"
														to={routes.CADASTRO}
														onClick={() => {
															closeMobileMenu()
														}}>
														CADASTRE-SE
													</Link>
												</div>
											</div>
										)}
										{isLoggedIn === null || !isLoggedIn ? (
											<div>
												<small>Já possui uma conta?</small>
												<Link
													to={routes.ENTRAR}
													onClick={closeMobileMenu}
													className="entrar white-when-desktop mt20">
													Faça Login!
												</Link>
											</div>
										) : null}
									</div>
									<div className="links-mobile">
										{muvicardUrl && hasMuvicard ? (
											<div className="scrollCardMenu">
												{this.renderMyCardMenu()}
											</div>
										) : (
											<div className="scrollmenu">
												{muvibusUrl
													? this.renderMuvibusMenu()
													: this.renderMenuItem()}
											</div>
										)}
									</div>
									{isLoggedIn && (
										<Link
											style={{ display: 'flex', order: '99' }}
											to="/"
											className="sair mobile"
											onClick={() => {
												closeMobileMenu()
												logout()
											}}>
											Sair
										</Link>
									)}
								</StyledLinksBlock>
							) : (
								<StyledLinksBlock className="menu__links-block">
									{isLoggedIn === null || !isLoggedIn ? (
										<Link
											to={routes.ENTRAR}
											onClick={closeMobileMenu}
											className="entrar white-when-desktop mt20">
											Entrar
										</Link>
									) : (
										<Link
											style={{ display: 'flex', order: '99' }}
											to="/"
											className="sair"
											onClick={() => {
												closeMobileMenu()
												logout()
											}}>
											Sair
										</Link>
									)}
									{!isLoggedIn && (
										<div className="cadastre-se-div">
											<span className="ganhe-descontos">
												GANHE DESCONTOS E MUITO MAIS!
											</span>
											<Link
												className="cadastre-se-btn"
												to={routes.CADASTRO}
												onClick={() => {
													closeMobileMenu()
												}}>
												CADASTRE-SE GRÁTIS
											</Link>
										</div>
									)}
								</StyledLinksBlock>
							)}
						</div>
					</div>
				</MenuSubContainer>
				{isMobileScreen && (
					<React.Fragment>
						<MenuHorizontal style={{ display: 'none' }}>
							<div
								onScroll={this.onScrollMenu}
								className={`scrollmenu scrollmenu-mobile-${isMobileScreen} scrollmenu-${this.state.scrollMenuClass}`}>
								{this.renderMenuItem()}
							</div>
						</MenuHorizontal>
						<StyledBackToTopBtn
							scrollNum={this.state.scroll}
							onClick={this.onClickBackToTop}>
							<FontAwesome name="arrow-up" />
						</StyledBackToTopBtn>
					</React.Fragment>
				)}
			</StyledContainerHeader>
		)
	}
}

const mapStateToProps = ({ user, site }) => ({
	...user,
	mobileMenuState: site.mobileMenuState
})

const mapDispatchToProps = dispatch =>
	bindActionCreators(
		{
			openMobileMenu: SiteCreators.openMobileMenu,
			closeMobileMenu: SiteCreators.closeMobileMenu,
			closePrivateMenu: SiteCreators.closePrivateMenu,
			logout: userActions.logout,
			resetRebookingData: TicketSaleCreators.resetRebookingData
		},
		dispatch
	)

const SiteHeader = withRouter(
	connect(mapStateToProps, mapDispatchToProps)(SiteHeaderComponent)
)
export default SiteHeader
